import styled from 'styled-components';

export const ModalSurface = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: min(620px, calc(100vw - 32px));
  max-height: calc(100vh - 48px);
  overflow: hidden;
  border-radius: 40px 40px 40px 0;
  background: ${(p) => p.theme.colors.light};
`;

export const ScrollArea = styled.div`
  max-height: calc(100vh - 48px);
  overflow-y: auto;
  padding: 36px 40px 40px;
  scrollbar-gutter: stable;

  @media (max-width: 639px) {
    padding: 28px 22px 30px;
  }
`;

export const ContactList = styled.div`
  display: grid;
  gap: 22px;
  margin: 26px 0 30px;
`;

export const ContactRow = styled.div`
  display: grid;
  gap: 8px;
`;

export const ExistingContact = styled.div`
  padding: 12px 14px;
  border: 1px solid ${(p) => p.theme.colors.gray100};
  border-radius: ${(p) => p.theme.radii.base};
  color: ${(p) => p.theme.colors.gray500};
  font-size: ${(p) => p.theme.fontSizes.base};
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  flex-wrap: wrap;
`;
